import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Full from '@/containers/Full'
import {removeToken, getToken} from "@/util";

// 把下面的路由 作懒加载处理
const Login = () => import('@/views/users/Login.vue')
const Register = () => import('@/views/users/Register.vue')

const Dashboard = () => import( '@/views/dashboard/Dashboard.vue')
const Resource = () => import( '@/views/resource/index')

const UserMaintain = () => import( '@/views/users/maintain/index')
const SalesPickupCustomer = () => import( '@/views/users/pickup-customer')
const UserProfile = () => import( '@/views/users/profile')
const RoleMaintain = () => import( '@/views/roles/maintain/index')
const MenuMaintain = () => import( '@/views/menus/maintain/index')
const DicMaintain = () => import( '@/views/dic/maintain/index')
const AreaMaintain = () => import( '@/views/areas/maintain/index')

const ProductMaintain = () => import( '@/views/products/maintain/index')
const ProductDetail = () => import( '@/views/products/maintain/detail')


const ItemMaintain = () => import( '@/views/items/maintain/index')
const ItemDetail = () => import( '@/views/items/maintain/detail')

const CustomerMaintain = () => import( '@/views/customers/maintain/index')
const CustomerDetail = () => import( '@/views/customers/maintain/detail')


const NotifyMessage = () => import( '@/views/notify/index')


const SalesCall = () => import( '@/views/report/index')
const SalesStatistic = () => import( '@/views/report/statistic')

const ItemStatistic = () => import( '@/views/report/item-statistic')
const ItemStatisticDetail = () => import( '@/views/report/item-statistic-detail')

const DailyReportStatistic = () => import( '@/views/report/daily-statistic')
const ReqFormsStatistic = () => import( '@/views/report/req-forms-statistic')
const MilesStatistic = () => import( '@/views/report/miles-statistic')
const MilesSubsidyStatistic = () => import( '@/views/report/miles-subsidy-statistic')
const MilesSubsidyForward = () => import( '@/views/report/miles-subsidy-forward')
const DeliveryStatistic = () => import( '@/views/report/delivery-statistic')
const ExportDailyTodo = () => import( '@/views/report/export-daily-todo')

const TodoMaintain = () => import( '@/views/todo/maintain/index')

const MockTodo = () => import( '@/views/todo/maintain/mock')

const TodoDetailMaintainForCust = () => import( '@/views/todo/cust-detail')
const TodoDetailReviewForCust = () =>   import( '@/views/todo/cust-detail-review')

const TodoDetailMaintainForMgr = () => import( '@/views/todo/mgr-detail')
const TodoDetailReviewForMgr = () => import( '@/views/todo/mgr-detail-review')

const DivManagerTodo = () => import( '@/views/todo/div-manager')
const DivManagerTodoReview = () => import( '@/views/todo/div-manager-review')

const FinManagerTodo = () => import( '@/views/todo/fin-manager')
const FinManagerTodoReview = () => import( '@/views/todo/fin-manager-review')

const DriverTodo = () => import( '@/views/todo/driver')
const DriverTodoReview = () => import( '@/views/todo/driver-review')

const SalesDriverTodo = () => import( '@/views/todo/sales-driver')
const SalesDriverTodoReview = () => import( '@/views/todo/sales-driver-review')

const OaTodo = () => import( '@/views/todo/oa')
const OaTodoReview = () => import( '@/views/todo/oa-review')

const OaPlanningTodo = () => import( '@/views/todo/oa-planning')
const OaPlanningTodoReview = () => import( '@/views/todo/oa-planning-review')


const PaintingTodo = () => import( '@/views/todo/painting')
const PaintingTodoReview = () => import( '@/views/todo/painting-review')

const BuyTodo = () => import( '@/views/todo/req-buy')
const BuyTodoReview = () => import( '@/views/todo/req-buy-review')

const PayTodo = () => import( '@/views/todo/req-pay')
const PayTodoReview = () => import( '@/views/todo/req-pay-review')

const ReqItemTodo = () => import( '@/views/todo/req-item')
const ReqItemTodoReview = () => import( '@/views/todo/req-item-review')

const PettyCashTodo = () => import( '@/views/todo/petty-cash')
const PettyCashTodoReview = () => import( '@/views/todo/petty-cash-review')

const ReqMilesTodo = () => import( '@/views/todo/req-miles')
const ReqMilesTodoReview = () => import( '@/views/todo/req-miles-review')

const InitTodo = () => import( '@/views/todo/maintain/init-todo')




const SignoffMaintain = () => import( '@/views/signoff/maintain/index')


const MySignoffMaintain = () => import( '@/views/my-signoff/maintain/index')

const Quotation = () => import( '@/views/quotation/index')
const QuotationDetail = () => import( '@/views/quotation/detail')
const ReqPayMaintain = () => import( '@/views/req-pay/maintain/index')
const ReqBuyMaintain = () => import( '@/views/req-buy/maintain/index')
const PettyCashMaintain = () => import( '@/views/petty-cash/maintain/index')
const ReqItemMaintain = () => import( '@/views/req-item/maintain/index')
const ReqMilesMaintain = () => import( '@/views/req-miles/maintain/index')

const Diagram = () => import( '@/views/charts/Diagram.vue')
const Slider = () => import('@/views/charts/Slider.vue')
const Tables = () => import( '@/views/tables/Tables.vue')
const List = () => import('@/views/tables/list/List.vue')
const Details = () => import('@/views/tables/details/Details.vue')
const Setting = () => import('@/views/setting/Setting.vue')
const NotFind = () => import('@/views/404.vue')

const DATA_MAINTAIN = "資料維護"
const DAILY_OPERATION = "日管作業"

Vue.use(Router)

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                title: '登入'
            }
        },
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Full',
            component: Full,
            meta: {
                breadcrumb: '首頁',
                title: '首頁',
                requireLogin: true
            },
            children: [

                {
                    path: '/init-todo/:jobType',
                    name: 'InitTodo',
                    component: InitTodo
                },
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: Dashboard,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '首頁主控台',
                        requireLogin: true
                    }
                },
                {
                    path: '/resource',
                    name: 'Resource',
                    component: Resource,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '資料下載',
                        requireLogin: true
                    }
                },
                {
                    path: '/users/maintain',
                    name: 'UserMaintain',
                    component: UserMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '帳號設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/sales-call',
                    name: 'SalesCall',
                    component: SalesCall,
                    meta: {
                        breadcrumb: "報表",
                        title: '客戶拜訪紀錄查詢',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/sales-statistic',
                    name: 'SalesStatistic',
                    component: SalesStatistic,
                    meta: {
                        breadcrumb: "報表",
                        title: '客戶拜訪統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/item-statistic',
                    name: 'ItemStatistic',
                    component: ItemStatistic,
                    meta: {
                        breadcrumb: "報表",
                        title: '用品使用統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/item-statistic-detail/:itemId/:userId',
                    name: 'ItemStatisticDetail',
                    component: ItemStatisticDetail,
                    meta: {
                        breadcrumb: "報表",
                        title: '用品使用統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/daily-statistic',
                    name: 'DailyReportStatistic',
                    component: DailyReportStatistic,
                    meta: {
                        breadcrumb: "報表",
                        title: '工作日誌統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/req-forms-statistic',
                    name: 'ReqFormsStatistic',
                    component: ReqFormsStatistic,
                    meta: {
                        breadcrumb: "報表",
                        title: '各類申請單統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/miles-statistic',
                    name: 'MilesStatistic',
                    component: MilesStatistic,
                    meta: {
                        breadcrumb: "報表",
                        title: '哩程統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/miles-subsidy-statistic',
                    name: 'MilesSubsidyStatistic',
                    component: MilesSubsidyStatistic,
                    meta: {
                        breadcrumb: "報表",
                        title: '哩程補貼統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/miles-subsidy-forward/:relatedTodoId',
                    name: 'MilesSubsidyForward',
                    component: MilesSubsidyForward,
                    meta: {
                        breadcrumb: "報表",
                        title: '哩程補貼統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/delivery-statistic',
                    name: 'DeliveryStatistic',
                    component: DeliveryStatistic,
                    meta: {
                        breadcrumb: "報表",
                        title: '拜訪間數統計',
                        requireLogin: true
                    }
                },
                {
                    path: '/report/export-daily-todo',
                    name: 'ExportDailyTodo',
                    component: ExportDailyTodo,
                    meta: {
                        breadcrumb: "報表",
                        title: '日報匯出',
                        requireLogin: true
                    }
                },
                {
                    path: '/users/set-customer/:salesId',
                    name: 'SalesPickupCustomer',
                    component: SalesPickupCustomer,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '目前負責的客戶',
                        requireLogin: true
                    }
                },
                {
                    path: '/user/profile',
                    name: 'UserProfile',
                    component: UserProfile,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '個人資訊',
                        requireLogin: true
                    }
                },
                {
                    path: '/roles/maintain',
                    name: 'RoleMaintain',
                    component: RoleMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '角色設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/sys/menu',
                    name: 'MenuMaintain',
                    component: MenuMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '選單設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/areas/maintain',
                    name: 'AreaMaintain',
                    component: AreaMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '區域設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/products/maintain',
                    name: 'ProductMaintain',
                    component: ProductMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '商品資料設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/product/detail/:pid',
                    name: 'ProductDetail',
                    component: ProductDetail,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '商品資料設定',
                        requireLogin: true
                    }
                },

                {
                    path: '/items/maintain',
                    name: 'ItemMaintain',
                    component: ItemMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '用品資料設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/item/detail/:id',
                    name: 'ItemDetail',
                    component: ItemDetail,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '用品資料設定',
                        requireLogin: true
                    }
                },
                
                {
                    path: '/signoff/maintain',
                    name: 'SignoffMaintain',
                    component: SignoffMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '簽核人員設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/message/my-signoff',
                    name: 'MySignoffMaintain',
                    component: MySignoffMaintain,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '我的簽核',
                        requireLogin: true
                    }
                },
                {
                    path: '/message/notification',
                    name: 'NotifyMessage',
                    component: NotifyMessage,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '訊息通知',
                        requireLogin: true
                    }
                },
                {
                    path: '/customers/maintain',
                    name: 'CustomerMaintain',
                    component: CustomerMaintain,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '客戶資料設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/customers/detail/:cid',
                    name: 'CustomerDetail',
                    component: CustomerDetail,
                    meta: {
                        breadcrumb: DATA_MAINTAIN,
                        title: '客戶資料設定',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo',
                    name: 'TodoMaintain',
                    component: TodoMaintain,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '我的工作日誌',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/mock-todo',
                    name: 'MockTodo',
                    component: MockTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '建立各角色工作日誌',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/cust/:mytodoId',
                    name: 'TodoDetailMaintainForCust',
                    component: TodoDetailMaintainForCust,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '工作日誌-客戶拜訪紀錄',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/cust/review/:jobId',
                    name: 'TodoDetailReviewForCust',
                    component: TodoDetailReviewForCust,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-客戶拜訪紀錄',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/mgr/review/:jobId',
                    name: 'TodoDetailReviewForMgr',
                    component: TodoDetailReviewForMgr,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-每日工作紀錄',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/mgr/:mytodoId',
                    name: 'TodoDetailMaintainForMgr',
                    component: TodoDetailMaintainForMgr,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '工作日誌-工作報表',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/painting/:mytodoId',
                    name: 'PaintingTodo',
                    component: PaintingTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '彩繪人員工作日誌',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/painting/review/:jobId',
                    name: 'PaintingTodoReview',
                    component: PaintingTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-彩繪人員工作日誌',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/req_buy/:mytodoId',
                    name: 'BuyTodo',
                    component: BuyTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '請購單',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/req_buy/review/:jobId',
                    name: 'BuyTodoReview',
                    component: BuyTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '請購單',
                        requireLogin: true
                    }
                },

                {
                    path: '/daily/todo/req_pay/:mytodoId',
                    name: 'PayTodo',
                    component: PayTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '請款單',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/req_pay/review/:jobId',
                    name: 'PayTodoReview',
                    component: PayTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '請款單',
                        requireLogin: true
                    }
                },

                {
                    path: '/daily/todo/req_item/:mytodoId',
                    name: 'ReqItemTodo',
                    component: ReqItemTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '用品請領單',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/req_item/review/:jobId',
                    name: 'ReqItemTodoReview',
                    component: ReqItemTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '用品請領單',
                        requireLogin: true
                    }
                },

                {
                    path: '/daily/todo/petty-cash/:mytodoId',
                    name: 'PettyCashTodo',
                    component: PettyCashTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '零用金請款',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/petty-cash/review/:jobId',
                    name: 'PettyCashTodoReview',
                    component: PettyCashTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '零用金請款',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/req_miles/:mytodoId',
                    name: 'ReqMilesTodo',
                    component: ReqMilesTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '哩程補貼申請',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/req_miles/review/:jobId',
                    name: 'ReqMilesTodoReview',
                    component: ReqMilesTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '哩程補貼申請',
                        requireLogin: true
                    }
                },

                {
                    path: '/daily/todo/div_mgr/:mytodoId',
                    name: 'DivManagerTodo',
                    component: DivManagerTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '區域主管-工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/div_mgr/review/:jobId',
                    name: 'DivManagerTodoReview',
                    component: DivManagerTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-區域主管工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/fin_mgr/:mytodoId',
                    name: 'FinManagerTodo',
                    component: FinManagerTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '財務主管-工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/fin_mgr/review/:jobId',
                    name: 'FinManagerTodoReview',
                    component: FinManagerTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-財務主管工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/driver/:mytodoId',
                    name: 'DriverTodo',
                    component: DriverTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '建材部-工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/driver/review/:jobId',
                    name: 'DriverTodoReview',
                    component: DriverTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-建材部工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/sales_driver/:mytodoId',
                    name: 'SalesDriverTodo',
                    component: SalesDriverTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '品牌業務-工作日報',
                        requireLogin: true
                    }
                }, 
                {
                    path: '/daily/todo/sales_driver/review/:jobId',
                    name: 'SalesDriverTodoReview',
                    component: SalesDriverTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-品牌業務工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/oa/:mytodoId',
                    name: 'OaTodo',
                    component: OaTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '內勤-工作日報',
                        requireLogin: true
                    }
                }, 
                {
                    path: '/daily/todo/oa/review/:jobId',
                    name: 'OaTodoReview',
                    component: OaTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '簽核-內勤工作日報',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/todo/oa_planning/:mytodoId',
                    name: 'OaPlanningTodo',
                    component: OaPlanningTodo,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '企畫-工作日報',
                        requireLogin: true
                    }
                }, 
                {
                    path: '/daily/todo/oa_planning/review/:jobId',
                    name: 'OaPlanningTodoReview',
                    component: OaPlanningTodoReview,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '企畫-工作日報',
                        requireLogin: true
                    }
                },                
                                
                {
                    path: '/daily/pay',
                    name: 'ReqPayMaintain',
                    component: ReqPayMaintain,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '請款單列表',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/buy',
                    name: 'ReqBuyMaintain',
                    component: ReqBuyMaintain,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '請購單列表',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/petty-cash',
                    name: 'PettyCashMaintain',
                    component: PettyCashMaintain,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '零用金請購單列表',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/item',
                    name: 'ReqItemMaintain',
                    component: ReqItemMaintain,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '用品請領單列表',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/miles',
                    name: 'ReqMilesMaintain',
                    component: ReqMilesMaintain,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '哩程補貼申請單列表',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/quotation',
                    name: 'Quotation',
                    component: Quotation,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '報價單列表',
                        requireLogin: true
                    }
                },
                {
                    path: '/daily/quotation/detail/:quotationId',
                    name: 'QuotationDetail',
                    component: QuotationDetail,
                    meta: {
                        breadcrumb: DAILY_OPERATION,
                        title: '填寫報價單',
                        requireLogin: true
                    }
                },
                {
                    path: '/sys/dictionary',
                    name: 'DicMaintain',
                    component: DicMaintain,
                    meta: {
                        breadcrumb: '系統設定',
                        title: '字典維護',
                        requireLogin: true
                    }
                },
                {
                    path: '/charts/diagram',
                    name: 'Diagram',
                    component: Diagram,
                    meta: {
                        breadcrumb: '图表一',
                        title: 'Diagram',
                        requireLogin: true
                    }
                },
                {
                    path: '/charts/slider',
                    name: 'Slider',
                    component: Slider,
                    meta: {
                        breadcrumb: '图表二',
                        title: 'Slider',
                        requireLogin: true
                    }
                },
                {
                    path: '/tables',
                    redirect: '/tables/list',
                    name: 'Tables',
                    component: Tables,
                    meta: {
                        breadcrumb: '表格',
                        requireLogin: true
                    },
                    children: [
                        {
                            path: '/tables/list',
                            name: 'List',
                            component: List,
                            meta: {
                                title: 'list',
                                breadcrumb: '列表',
                                requireLogin: true
                            }
                        },
                        {
                            path: '/tables/details',
                            name: 'Details',
                            component: Details,
                            meta: {
                                title: 'details',
                                breadcrumb: '详情',
                                requireLogin: true
                            }
                        }
                    ]
                },
                {
                    path: '/setting',
                    name: 'Setting',
                    component: Setting,
                    meta: {
                        breadcrumb: '设置',
                        requireLogin: true
                    },
                }
            ]
        },
        {
            path: '*',
            name: 'NotFind',
            component: NotFind,
            meta: {
                title: '404'
            }
        }
    ]
})

// 页面刷新时，重新赋值token
if (localStorage.getItem('token')) {
    store.commit('BIND_LOGIN', localStorage.getItem('token'))
}

// 全局导航钩子
router.beforeEach(async (to, from, next) => {
    // determine whether the user has logged in
    // const loginToken = store.state.login.token
    const loginToken = getToken('LH_TOKEN')
    const username = store.state.login.userInfo.username
    console.log('to=', to.path, ' from=', from.path, 'token=', loginToken)

    //已登入過
    if (loginToken) {
        console.log('beforeEach: 已登入過')
        //已登入，不能再進入登入頁
        if (to.path === '/login') {
            console.log('beforeEach: 已登入，不能再進入登入頁')
            next(false)
        } else {
            console.log('beforeEach 會員資料:', username)

            if (username) {
                //會員資料在本地store仍存在，放行
                next()
            } else {
                //會員資料不在
                console.log('beforeEach: 會員資料不在，重撈會員資料:')
                try {
                    //重撈會員資料
                    await store.dispatch('login/getUserInfo', loginToken)
                    await store.dispatch('login/getUserBadge')
                    next()
                } catch (e) {
                    console.log('beforeEach: 撈會員資料失敗，重新登入', e)
                    removeToken('LH_TOKEN')
                    store.state.login.token = null
                    next('/login')
                }
            }
        }
    } else {
        console.log('beforeEach 未登入:', to.path)
        if (to.path === '/login') {
            next()
        } else {
            next('/login?redirect='+to.path)
        }
    }


})

export default router
